export default class EventInsightsService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.$q = $q;
    this.ngAuthSettings = ngAuthSettings;
  }

  loadEventInsightsData(accountId, requestData) {
    const url = this.#getBaseEventInsightsUrl(accountId);
    
    return this.$http.post(url, requestData).then((response) => {
      return this.#handleInsightsDataResponse(response, requestData);
    });
  }

  #handleInsightsDataResponse(response) {
    const records = response.data.report.records;
    const totalsRecord = this.#getTotalRows(records, ['targetName']);

    return {
      allRecords: records,
      totalsRecord,
      partialResult: response.data.report.partialResult,
    };
  }

  #getTotalRows(records, groupByColumns) {
    const totalIndex = records.findIndex(record => {
      let isTotals = true;
      groupByColumns.some(column => {
        isTotals = typeof record[column] === 'undefined';

        return !isTotals;
      });

      return isTotals;
    });

    return records.splice(totalIndex, 1);
  }

  #getBaseEventInsightsUrl(accountId) {
    return `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/insights/events/beta`;
  }
}